module.exports = __webpack_public_path__ + "static/img/manual-26.79d6739.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-26.png
// module id = 9BZ2
// module chunks = 4